module.exports = __webpack_public_path__ + "static/media/Bounce1-nb-lightgreen.3b20147d.png";